// 'use strict';
//import $ from "jquery";
//import jQuery from "jquery";
//window.$ = window.jQuery = $;

import * as Sentry from "@sentry/browser";
import _ from "underscore";
import bodymovin from "lottie-web";
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupA11yPlugin from '@swup/a11y-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupProgressPlugin from '@swup/progress-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupDebugPlugin from '@swup/debug-plugin';
import { Modal } from 'bootstrap';
//import { loadJScrollpane } from '@js/utils/loadjscrollpane';
// import { loadBootstrapModal } from '@js/utils/loadbootstrap';
// import { Fancybox } from "@fancyapps/ui";
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import VanillaTilt from 'vanilla-tilt';
import AOS from 'aos';
import Isotope from "isotope-layout";
import Packery from "isotope-packery";
import classie from "desandro-classie";
// import '@js/vendor/cycle2.js';
// import '@js/vendor.js'
// import '@js/gdpr-cookies.js';
//import '@js/motum_map.js'
//import '@js/our_work.js'
import '@js/template_scripts.js';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
//import '@js/vendor/jquery.fancybox.min.js'
import { Fancybox } from "@fancyapps/ui";
import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import Draggable from 'gsap/Draggable';
import Lenis from 'lenis'
// import 'bootstrap/dist/css/bootstrap.min.css';
import * as bootstrap from 'bootstrap'

Sentry.init({
    dsn: "https://d9cec6d3fb154f33b5a20d32ee0c9bc0@o4511259662221312.ingest.us.sentry.io/4511259705540608",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/configuration/options/#sendDefaultPii
    integrations: [Sentry.browserTracingIntegration()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Distributed tracing: attach sentry-trace headers only to same-site requests (Craft/XHR).
    tracePropagationTargets: [
        "localhost",
        /^https?:\/\/motumb2b\.ddev\.site/,
        /^https:\/\/motum-craft\.staging\.servd\.dev/,
        /^https:\/\/(www\.)?motumb2b\.com/,
    ],
    sendDefaultPii: true,
    environment: (typeof window !== 'undefined' && window.__CRAFT_ENVIRONMENT__) || 'production',
    release: "motum@2.3.12",
    beforeSend(event, hint) {
        // Drop all events on local environments
        const siteEnvironment = window.__CRAFT_ENVIRONMENT__ || 'production';
        if (siteEnvironment === 'local' || siteEnvironment === 'dev') {
            return null;
        }

        // Ignore errors from browser extensions
        const blockedSchemes = [
            "chrome-extension://",
            "moz-extension://",
            "safari-extension://",
            "webkit-extension://",
        ];
        if (
            event.exception?.values?.[0]?.stacktrace?.frames?.some((frame) =>
                blockedSchemes.some((scheme) =>
                frame.filename?.startsWith(scheme)
                )
            )
        ) {
            return null;
        }

        // Craft global with list of known errors to not bother sending, save on event budget
        const blocklist = window.__SENTRY_BLOCKLIST__ || [];
        if (blocklist.length > 0) {
            const errorMessage = event.exception?.values?.[0]?.value ?? event.message ?? '';
            if (blocklist.some((blocked) => blocked && errorMessage.includes(blocked))) {
                return null;
            }
        }

        return event;
    },
});


gsap.registerPlugin(SplitText, ScrollTrigger, EaselPlugin, Draggable); 

$(document).ready(function(){
    $(document).on('click', '.js-toggle-mobile-nav', function(e){
        $(this).toggleClass('active');
        $('.main-nav').fadeToggle().css('display', 'flex');
        $('body').toggleClass('mobile-menu-open');
    });

    $(document).on('click', '.header a, .mobile-nav a', function(e){
        $('.menu-toggle').removeClass('active');
        $('.main-nav li').removeClass('active');
        $('.mobile-nav li').removeClass('active');
        $(this).parent().addClass('active');
    });

    $(document).on('click', '.specialties-nav a', function(e){
        $('.specialties-nav li').removeClass('active');
        $(this).parent().addClass('active');
    });

    $(document).on('click', '.js-scroll-to', function(e){
        var scrollTarget = $(this).attr('scroll-to');
        $('html, body').animate({
            scrollTop: $('.'+scrollTarget).offset().top
        }, 1000);
    });

    $(document).on('click', '.js-slow-scroll-to', function(e){
        var scrollTarget = $(this).attr('scroll-to');
        $('html, body').animate({
            scrollTop: $('.'+scrollTarget).offset().top
        }, 2000);
    });

    $(document).on('click', '.js-sticky-scroll-to', function (e){
        var scrollTarget = $(this).attr('scroll-to');
        var scrollOffset = largerScreen.matches ? 180 : 50;
        $('html, body').animate({
            scrollTop: $(scrollTarget).offset().top - scrollOffset
        }, 500);
    });


    // ** Nav disappearing bug fix when browser width is adjusted **
    // --- 
    // Anything larger than desktop small width (1200px + 1px) (AKA desktop nav):
    const largerScreen = window.matchMedia("(min-width: 1201px)");
    
    const adjustNav = function(largerScreen) {
        const menuToggle = document.querySelector(".menu-toggle");
        const pageBody = document.querySelector("body");
        const mainNav = document.querySelector('.main-nav');
        if (largerScreen.matches){
        // At larger screen width: 
            // show nav even after mobile nav has been closed (no more disappearing)
            mainNav.style.display = "flex";
            menuToggle.style.display = "none";
            // remove dark background overlay
            pageBody.classList.remove("mobile-menu-open");
        } 
        else {
        // At smaller screen width: 
            // re-hide mobile nav links and display menu toggle button
            if(mainNav.style.display === "flex") {
                mainNav.style.display = "none";
                menuToggle.style.display = "block";
            }
            // if menu was already open at mobile screen width, continue to have it open
            if (menuToggle.classList.contains("active")) {
                mainNav.style.display = "flex";
                pageBody.classList.add("mobile-menu-open");
            }
        } 
    }
    
    largerScreen.addEventListener('change', () => {
        adjustNav(largerScreen);
    })



    //BLOG PAGE STICKY ARTICLE NAV
    // init the observer
    const changeNav = (entries => {
        entries.forEach((entry) => {
            const id = entry.target.getAttribute('id');
            let blogNavLink = document.querySelector(`.blog-sticky-nav button[scroll-to="#${id}"]`);
            if (blogNavLink){
                if (entry.isIntersecting && entry.intersectionRatio > 0) {
                    blogNavLink.parentElement.classList.add('active');
                } else {
                    blogNavLink.parentElement.classList.remove('active');
                }
            }
        });
    });

    const options = {
        rootMargin: "-45% 0px -55% 0px",
        //threshold: 1,
    };
    const blogObserver = new IntersectionObserver(changeNav, options);

    //BLOG AND LANDING PAGE VIDEO AUTO PLAY
    const videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                entry.target.play()
            } else {
                entry.target.pause()
            }
        });
    });
    
    // Run animation preloader
    var loaderAnimation = bodymovin.loadAnimation({
        container: document.getElementById('transition-loader'), // Required
        path: '/animation_data/loader/data.json', // Required
        renderer: 'svg', // Required
        loop: true, // Optional
        autoplay: false // Optional
    });

    /////////////////////////////////////////////////////////////////////////////
    // Footer newsletter signup 

    // const handleFormPageLoad = function() {
    //     if (document.querySelector('body').classList.contains('page-contact/stay-informed')) {
    //         // console.log('newsletter form page loading')
    //         let submittedEmail = sessionStorage.getItem("newsletterSignupEmail");
    //         setTimeout(function() {
    //             const emailInput = document.querySelector("input[name='email']");
    //             if (emailInput) {
    //                 emailInput.value = submittedEmail;
    //             }
    //             // sessionStorage.removeItem("newsletterSignupEmail");
    //         }, 800)
    //     }
    // }

    // const handleNewsletterSubmit = function() {
    //     const newsletterSignupInput = document.getElementById('newsletterSignup');
    //     const newsletterSignupSubmitButton = document.getElementById('newsletterSubmit');

    //     const handleEmailAutofill = function() {
    //         sessionStorage.setItem("newsletterSignupEmail", newsletterSignupInput.value.trim());
    //         window.location.href = "/contact/stay-informed";
    //         handleFormPageLoad();
    //     }

    //     if (newsletterSignupSubmitButton) {
    //         newsletterSignupSubmitButton.addEventListener('click', () => {
    //             if (newsletterSignupInput.value.trim() !== "") {
    //                 handleEmailAutofill();
    //             }
    //         })
    
    //         newsletterSignupInput.addEventListener('keyup', (e) => {
    //             if (e.key === 'Enter' && newsletterSignupInput.value.trim() !== "") {
    //                 handleEmailAutofill();
    //             }
    //         })
    //     }
       
    // }

    // const handleSubmitButtonChange = function(input) {
    //     if (input !== '') {
    //         newsletterSignupSubmitButton.setAttribute('href', '/contact/stay-informed');
    //     } else {
    //         newsletterSignupSubmitButton.setAttribute('href', 'javascript:void(0)');
    //     }
    // }

    // newsletterSignupInput.addEventListener('input', (e) => {
    //     // handleSubmitButtonChange(e.target.value.trim());
    //     if (e.target.value.trim() !== '') {
    //         // handleSubmitClick(e.target.value.trim());
    //     }
    // })
    /////////////////////////////////////////////////////////////////////////////

    //import Swup from 'swup';
    const swup = new Swup({
      //  debugMode: true,
        containers: ["#swup", '#header'],
        cache: true,
        animateHistoryBrowsing: true,
        plugins: [
            new SwupBodyClassPlugin(),
            new SwupScrollPlugin(),
            new SwupPreloadPlugin(),
            new SwupA11yPlugin({
                contentSelector: 'body',
            }),
            new SwupProgressPlugin({
                className: 'swup-progress-bar',
                transition: 1000,
                delay: 300
            }),
            new SwupScriptsPlugin(),
            // new SwupDebugPlugin()
        ],
        linkSelector:
            'a[href^="' + window.location.origin +'"]:not([data-no-swup]):not([target="_blank"]):not([href*="/contact"]), ' +
            'a[href^="/"]:not([data-no-swup]):not([target="_blank"]):not([href*="/contact"]), ' +
            'a[href^="#"]:not([data-no-swup]):not([target="_blank"])'
    });

    // Keep a stable jQuery reference with Cycle2 attached; some injected scripts
    // can replace window.$ / window.jQuery during Swup navigation.
    const baseJQuery = window.jQuery;
    const restoreBaseJQuery = function() {
        if (baseJQuery && window.jQuery !== baseJQuery) {
            window.$ = window.jQuery = baseJQuery;
        }
    };
 
    
    // Add is-visible class on load, and after transition
    $('body').addClass('is-visible');
    $('html').addClass('first-load');


    // Remove initial is-animating class to trigger animations on page load
    $('html').removeClass('is-animating');
    swup.hooks.on('page:view', function() {
        $('body').addClass('is-visible');
    });

    swup.hooks.on('animation:out:end', function() {
      //  alert('pageloaded');
    });
    swup.hooks.on('animation:out:start', function() {
        loaderAnimation.stop();
        setTimeout(function(){
            loaderAnimation.play();
        }, 300);
        $('body').removeClass('is-visible');

    });
    swup.hooks.on('page:preload', function() {

        // console.log($('.specialty-header').outerHeight());
        $('.specialty-header-placeholder').css('height', $('.specialties-index-wrapper').outerHeight());
    });

    let scrollHandler;
    let onPageTimer;
    let lenis = null;

    // Run init function initially
    init();
    // Run init on each page load
    swup.hooks.on('page:view', init);

    // Required for video autoplaying on Safari when navigating by Swup 
    swup.hooks.on('page:view', function() {
        document.querySelectorAll('video[autoplay]').forEach(function(video) {
            if (video.networkState !== HTMLMediaElement.NETWORK_EMPTY) {
                return;
            }
            video.load();
            const playing = video.play();
            if (playing) {
                playing.catch(function() {});
            }
        });
    });

    // "Carousel" sliders are always a carousel. "Blocks" sliders
    // (data-show-in-carousel="0") are a static grid on tablet/desktop and only
    // become a carousel on mobile.
    let testimonialsResizeHandler = null;

    function destroyTestimonialsSlider() {
        if (testimonialsResizeHandler) {
            window.removeEventListener('resize', testimonialsResizeHandler);
            testimonialsResizeHandler = null;
        }

        $('.testimonials-slider').each(function () {
            const $slider = $(this);
            // Remove namespaced listeners added during init to avoid stacking.
            $slider.off('.testimonialsCycle');
            // Destroy existing Cycle2 instance before Swup replaces/restores content.
            if ($slider.data('cycle.API')) {
                $slider.cycle('destroy');
            }
        });
    }

    const INLINE_CYCLE_SLIDESHOWS = [
        '.testimonial__slideshow',
        '.client-list__slideshow',
        '.home_solutions-testimonials-slider',
    ].join(', ');

    function destroyInlineCycleSliders() {
        if (typeof $.fn.cycle !== 'function') {
            return;
        }

        $(INLINE_CYCLE_SLIDESHOWS).each(function () {
            const $slider = $(this);
            if ($slider.data('cycle.API')) {
                $slider.cycle('destroy');
            }
        });
    }

    // Init/destroy each slider's carousel to match the current viewport.
    function syncTestimonialsSliders() {
        // Swup can execute inline scripts before page-specific assets are ready.
        if (typeof $.fn.cycle !== 'function') {
            return;
        }

        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        $('.testimonials-slider').each(function () {
            const $slider = $(this);
            const carouselAlways = $slider.attr('data-show-in-carousel') !== '0';
            const shouldCarousel = carouselAlways || isMobile;
            const isActive = !!$slider.data('cycle.API');

            if (shouldCarousel && !isActive) {
                $slider.cycle({
                    fx: 'scrollRight',
                    sync: false,
                    timeout: 8000,
                    slides: '> div',
                    pager: $slider.siblings('.testimonials-slider__pager'),
                    pagerTemplate: `<button 
                        class="testimonials-slider__pager-btn" 
                        data-hs-track="true" 
                        data-hs-event="proof_point_click" 
                        data-hs-proof-type="review_rating" 
                        data-hs-proof-name="testimonial_rating" 
                        data-hs-proof-location="testimonial_section" 
                        data-hs-card-position="{{slideNum}}">
                            <span class="sr-only">Go to slide</span>
                        </button>`,
                    autoHeight: 'calc',
                    log: false
                });
                // Refresh ScrollTrigger since Cycle2 can shift layout after bootstrap.
                $slider.off('cycle-bootstrap.testimonialsCycle').on('cycle-bootstrap.testimonialsCycle', function () {
                    ScrollTrigger.refresh();
                });
            } else if (!shouldCarousel && isActive) {
                $slider.off('.testimonialsCycle');
                $slider.cycle('destroy');
                ScrollTrigger.refresh();
            }
        });
    }

    function initTestimonialsSlider() {
        if (!$('.testimonials-slider').length) {
            return;
        }

        syncTestimonialsSliders();

        // Re-evaluate on resize so blocks ⇄ carousel switches at the breakpoint.
        if (!testimonialsResizeHandler) {
            let resizeTimer;
            testimonialsResizeHandler = function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(syncTestimonialsSliders, 200);
            };
            window.addEventListener('resize', testimonialsResizeHandler);
        }
    }

    

    function unload() {
        restoreBaseJQuery();

        //  if ($('[src^="https://maps.googleapis.com/maps"]').length){
        //     $('[src^="https://maps.googleapis.com/maps"]').each(function(){
        //         $(this).remove();
        //     })
        //  }
        if ($('.blog-sticky-nav')[0]){
            removeStickyBlogNav()
        }

        //for blog video play on scroll 
        if ($('.video-block__video--play-on-scroll')[0]){
            removePlayVideoOnScroll()
        }

        destroyTestimonialsSlider()

        destroyInlineCycleSliders()

    }
    
    swup.hooks.on('content:replace', unload, { before: true });

    function init() {
        restoreBaseJQuery();

        // autorun fancybox
        /**** 
         * added autoStart: false -WM ****/

        //init fancy box
        Fancybox.bind("[data-fancybox]", {
            Keyboard: true,
            PreventCaptionOverlap: false,
            Infobar: false,
            Buttons: [
                "thumbs",
                "fade",
                "close"
            ],
            idleTime: 300,
            Touch:{
                vertical : false,
                momentum : false
            },
            ClickContent:false,
            AnimationEffect:"fade",
            Hash: false,
            SlideShow: {
                autoStart: false,
                speed: 3000
            },
        });

        // Initialize Lenis. It binds to the window, which Swup never replaces, so a
        // single instance has to persist across navigations - building a new one on
        // every page:view left the previous ones running and fighting over scroll.
        if (!lenis) {
            lenis = new Lenis({
                autoRaf: true
            });
        } else {
            lenis.resize();
        }

        // Focus scroll within search modal on search button click by add Lenis prevent attribute
        var buttonOpen = document.querySelector("#searchButton");
        buttonOpen.addEventListener("click", () => {
            var ss360Modal = document.querySelector(".ss360-layer");
            if (ss360Modal) {
                ss360Modal.setAttribute("data-lenis-prevent", "");
            }
        }) 

        // autorun tilt
        VanillaTilt.init(document.querySelectorAll(".js-tilt"), {
            glare: false,
            maxGlare: .5,
            max:        3,
            scale:          1.02,
            speed:          1000,
        });

        // Init Animate on Scroll Library
        AOS.init({
            // Global settings:
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
            initClassName: 'aos-init', // class applied after initialization
            animatedClassName: 'is-in-view', // class applied on animation
            useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
            disableMutationObserver: false, // disables automatic mutations' detections (advanced)
            debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
            throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


            // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
            offset: 120, // offset (in px) from the original trigger point
            delay: 0, // values from 0 to 3000, with step 50ms
            duration: 400, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
            once: false, // whether animation should happen only once - while scrolling down
            mirror: false, // whether elements should animate out while scrolling past them
            anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

        });


        // var activePageSlug = $('#active-page-slug').attr('slug');
        // $('.navigation li').removeClass('active');
        // $('.navigation li[slug="'+activePageSlug+'"]').addClass('active');


        var scrollThrottleTimeout;
        $(window).bind(
            'scroll',
            function()
            {
                if (!scrollThrottleTimeout) {
                    scrollThrottleTimeout = setTimeout(
                        function()
                        {
                            //  console.log('test');
                            onPageScroll();
                            scrollThrottleTimeout = null;
                        },
                        100
                    );
                }
            }
        );

        var prevScrollpos = window.pageYOffset;
        function onPageScroll(){
            window.onscroll = function() {
                var currentScrollPos = window.pageYOffset;
                // if (prevScrollpos > currentScrollPos) {
                //     $('.header').removeClass('header--is-hidden');
                // } else if (currentScrollPos > 200) {
                //     $('.header').addClass('header--is-hidden');
                // }
                prevScrollpos = currentScrollPos;
            }

            // console.log("Scrolled");
            if ($(window).scrollTop() > 0) {
                $('.header').addClass('header--is-fixed');
                $('body').addClass('header-fixed');
            } else {
                $('.header').removeClass('header--is-fixed');
                $('body').removeClass('header-fixed');
            }


            if ($(window).scrollTop() >= 500) {
                $('.social-share-buttons').addClass('fixed');
            } else {
                $('.social-share-buttons').removeClass('fixed');
            }

            if ($('.blog--has-sticky-nav')){
                let imgHeight = $('.post-header__img')[0] ? $('.post-header__img').height() : 0;
                if ($(window).scrollTop() >= (450 + imgHeight)) {
                    $('.social-share-buttons').addClass('sticky-nav--fixed');
                } else {
                    $('.social-share-buttons').removeClass('sticky-nav--fixed');
                }
            }


            if ($('.subspecialty-rows')[0]){
                if ($(window).scrollTop() >= ($('.subspecialty-rows').position().top + 100)) {
                    $('.specialty-fixed-header').addClass('is-visible');
                }  else {
                    $('.specialty-fixed-header').removeClass('is-visible');
                }
            }
        }

        if (document.querySelector('#team-line')) {
            initTeamPage();
            // something like new Carousel('#carousel')
        }

        if (document.querySelector('#our-work-index')) {
            initOurWorkIndex();
        }

        if ($('.our-work-card')[0]) {
            initOurWorkCard();
        }

        // if (document.querySelector('#intro-video')) {
        //     initHomeVideo();
        // }

        if ($('.fancy-cursor')[0]){
            initFancyCursor();
        }

        if ($('.home_hero')[0]){
            initGeneralAnimations();
            initHome();
        }

        if ($('.landing-page__header')[0]){
            initGeneralAnimations();
            initLandingPage();
        }

        if ($('.holiday-interactive')[0]){
            initHolidayInteractive();
        }

        if ($('.case-study__header-visual-outer')) {
            initCaseStudyHeader();
        }

        if ($('.image-video__video--play-on-scroll')[0] || $('.hero-media-row__video--play-on-scroll')[0]){
            initCaseStudyVideoOnScroll()
        }

        if ($('.process-sections')[0]) {
            initProcessSVG();
        }

        if ($('form #country-input')[0]){
            initCountryOptin();
        }

        if ($('.specialties-index-card')[0]) {
            $('.specialties-index-card').click(function(){
                $(this).addClass('is-active');

                // Reposition transition circle to card
                var left = $(this).offset().left + ($(this).outerWidth() / 2);
                var top = $(this).offset().top + ($(this).outerHeight() / 2);
                $('.specialty-header-placeholder__inner').css('left', left).css('top', top);
            });
        }

        if ($('.blog-sticky-nav')[0]){
            initStickyBlogNav()
        }

        //blog video play on scroll
        if ($('.video-block__video--play-on-scroll')[0]){
            initPlayVideoOnScroll()
        }


        //INIT BAMBOO CAREERS 
        //This still necessary as swup scripts plugin doesn't help the document.write issue with this script 
        if (document.querySelector('#BambooHR')) {
            // Used the relevant code from https://motumb2b.bamboohr.com/js/jobs2.php 
            var embedUrl = "https://motumb2b.bamboohr.com/jobs/embed2.php";

            var xmlhttp;
            var ieFlag = 0;
            if (('XDomainRequest' in window && window.XDomainRequest !== null) && document.documentMode < 10) {
                xmlhttp=new XDomainRequest();
                ieFlag = 1;
            } else if (window.XMLHttpRequest) {
                xmlhttp=new XMLHttpRequest();
            } else {
                xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
            } 

            function loadd() { //needed for IE9 CORS
                var content = xmlhttp.responseText;
                var footerId="BambooHR-Footer";
                var fel=document.getElementById(footerId);

                var divId="BambooHR-ATS";
	            var el=document.getElementById(divId);
        
                el=document.getElementById(divId);

                el.innerHTML=content;
            }

            try{
                xmlhttp.onload = loadd;
                xmlhttp.open("GET",embedUrl);
                xmlhttp.send();
            } catch(e){
                console.log(e)
            }    
        }

        // Stop Swup from running on BambooHR links that are dynamically added
        var bambooHR = document.querySelector('#BambooHR-ATS');
        var bamboo_config = { childList: true, subtree: true };

        var bamboo_callback = function() {
            document.querySelectorAll("#BambooHR a").forEach( anchor => {
                anchor.setAttribute('data-no-swup', true)
                anchor.setAttribute('target', "_blank")
            })
        };

        var searchObserverBamboo = new MutationObserver(bamboo_callback);
    
        if (bambooHR && bambooHR.nodeType === Node.ELEMENT_NODE){
            searchObserverBamboo.observe(document.getElementById('BambooHR'), bamboo_config);
        } 
        //if it loads before this code runs, catch it here
        if (document.querySelector(".BambooHR-ATS-Jobs-List")){
            document.querySelectorAll("#BambooHR a").forEach( anchor => {
                //console.log("bamboo clean");
                anchor.setAttribute('data-no-swup', true)
                anchor.setAttribute('target', "_blank")
            })
        }	

        //INIT GENERAL CONTACT
        if (document.querySelector('#generalContact')){
            //find checkbox by name
            $('.checkboxes input[type=checkbox].js-im-interested-in-hidden').on('change', function() {
                var InterestedInValues = $('.checkboxes input[type=checkbox]:checked').map(function() {
                    return $(this).val();
                }).get().join(', ');
                //console.log(InterestedInValues);
                //add the values to the hidden field
                $('#form-input-imInterestedInHidden').val(InterestedInValues);
            
            });
        }
        // if (document.querySelector('#stayInformed')){
        //     initAOForm('stayInformed', '0014')
        // }

        // handleNewsletterSubmit();
        // handleFormPageLoad();



        ////////////////////////////////////////
        // RESET for Cookieless analytics - clear previous listeners
        // (this is primarily for Swup because changing pages aren't always registered as new pages)

        // Clear previous scroll listener
        if (scrollHandler) {
            window.removeEventListener('scroll', scrollHandler);
            scrollHandler = null;
        }

        // Clear previous timer
        if (onPageTimer) {
            clearInterval(onPageTimer);
            onPageTimer = null;
        }
        
        console.log(window.__analyticsListenersAttached)
        window.__analyticsListenersAttached = false;
        console.log(window.__analyticsListenersAttached)
        
        // Call the actual handleCookielessAnalytics function:
        // Cookieless analytics should only run on key content pages
        // -- key content page types include services, portfolio, and blog
        const urlPath = window.location.pathname;
        const isKeyContentType =
            urlPath.includes("/specialties") ||
            urlPath.includes("/our-work") ||
            urlPath.includes("/thinking-business-to-business-marketing");

        if (isKeyContentType && !window.__analyticsListenersAttached) {
            handleCookielessAnalytics();
        }
    } 

//     function initAOForm(formID, fid){
//         // console.log("running initAOForm")
//         /* Act-On Form Information */
//         //http://a9952.actonsoftware.com/acton/form/9952/001b:d-0001/0/-/-/-/-/index.htm
//         //http://[server]/acton/form/[aid]/[fid]:[did]/0/index.htm
//         var aoProtocol = location.protocol;
//         if ( aoProtocol.indexOf('http') < 0 ) aoProtocol = 'http:';
//         var aoCAP = {
//             aid: '9952',
//             fid: fid,
//             did: 'd-0001',
//             server: 'a9952.actonsoftware.com',
//             formId: formID,
//             protocol: aoProtocol
//         };
//         var aoArr = aoArr || []; aoArr.push(aoCAP);
//         /* --------- */

//         // If form is valid, set variable so Act-On script can do its job
//         // formElement.validator().on('submit', function (e) {
//         //     if (e.isDefaultPrevented()) {
//         //         formIsValid = false;
//         //     } else {
//         //         formIsValid = true;
//         //     }
//         // });
//         function AoProcessForm(formelement) {
//             for (AoI = 0; AoI < aoArr.length; AoI++) {
//                 if ( aoArr[AoI].aid && aoArr[AoI].fid && aoArr[AoI].did && aoArr[AoI].server && ( aoArr[AoI].formId || aoArr[AoI].formName )) {
//                     var d = document,
//                         thisFormId = formelement.id || '',
//                         thisFormName = formelement.name || '',
//                         bi = function(i) {
//                             return d.getElementById(i)
//                         },
//                         bn = function(i) {
//                             return d.getElementsByName(i)[0]
//                         },
//                         names = [],
//                         values = [],
//                         params = {},
//                         w = window,
//                         targetIdOrName = aoArr[AoI].formName ? bn(aoArr[AoI].formName) : bi(aoArr[AoI].formId),
//                         len = targetIdOrName.elements.length,
//                         isLoaded = false,
//                         ud = 'undefined',
//                         st = function(f, i) {
//                             w.setTimeout(f, i)
//                         },
//                         ce = function(t) {
//                             return d.createElement(t)
//                         },
//                         gid = function(p) {
//                             var j, i = 0,
//                                 n = Math.random,
//                                 r = [],
//                                 c = '0123456789abcdef'.split('');
//                             for (; i < 16; i++) r[i] = c[(0 | n() * 16) & 0xf];
//                             j = p + r.join('');
//                             return bi(j) == null ? j : gid(p);
//                         },
//                         addInput = function( form, name, value )
//                     {
//                         var el = ce('input');
//                         el.name = name;
//                         el.value = value;
//                         form.appendChild( el );
//                     },
//                         idifr = gid('aoCapT');
//                     if (aoArr[AoI].formName == thisFormName || aoArr[AoI].formId == thisFormId) {
//                         var dTarget = ce('div');
//                         dTarget.style.display = 'none';
//                         d.body.appendChild(dTarget);
//                         dTarget.innerHTML = '<iframe name="' + idifr + '" id="' + idifr + '"><\/iframe>'; // generate iframe
//                         var dForm = ce('form'), idform = gid('aoCapD');
//                         dForm.id = idform;
//                         dForm.style.display = "none";
//                         dForm.method = 'POST';
//                         dForm.enctype = 'multipart/form-data';
//                         dForm.acceptCharset = 'UTF-8';
//                         dForm.target = idifr; // form targets iframe
//                         dForm.action = (aoCAP.protocol || w.location.protocol) + '//' + aoCAP.server + '/acton/forms/userSubmit.jsp';
//                         d.body.appendChild(dForm); // generate form
//                         for (i = 0; i < len; i++) {
//                             var el = targetIdOrName.elements[i];
//                             var name = typeof(el.name) != ud ? el.name : null;
//                             var value = typeof(el.value) != ud ? el.value : null;
//                             tagName = el.nodeName.toLowerCase();
//                             if (tagName == 'input' && (el.type == 'radio' || el.type == 'checkbox') && !el.checked) {
//                                 name = null;
//                             } else if (tagName == 'select' && el.selectedIndex && el.selectedIndex != -1 && el.options[el.selectedIndex] && el.options[el.selectedIndex].value)
//                             {
//                                 value = el.options[el.selectedIndex].value
//                             };
//                             if (name != null && name != '') {
//                                 names.push(name);
//                                 values.push(el.value);
//                                 console.log("Element name: " + el.name + " / Element value: " + el.value);
//                                 params[name] = el.value;
//                             };
//                             addInput( dForm, el.name, el.value );
//                         }
//                         aoCAP.pid = 0;
//                         aoCAP.cuid = aoCAP.cuid || '';
//                         aoCAP.srcid = aoCAP.srcid || '';
//                         aoCAP.camp = aoCAP.camp || '';
//                         addInput( dForm, 'ao_a', aoArr[AoI].aid );
//                         addInput( dForm, 'ao_f', aoArr[AoI].fid );
//                         addInput( dForm, 'ao_d', aoArr[AoI].fid+":"+aoArr[AoI].did );
//                         addInput( dForm, 'ao_p', 0 );
//                         addInput( dForm, 'ao_jstzo', new Date().getTimezoneOffset() );
//                         addInput( dForm, 'ao_form_neg_cap', '' );
//                         addInput( dForm, 'ao_refurl', d.referrer );
//                         addInput( dForm, 'ao_cuid', aoCAP.cuid );
//                         addInput( dForm, 'ao_srcid', aoCAP.srcid );
//                         addInput( dForm, 'ao_camp', aoCAP.camp );
//                         bi(idform).submit();
//                         var dTargetFrame = bi( idifr );
//                         dTargetFrame.onload = function() {
//                             isLoaded = true;
//                         };
//                         var waitForSubmit = function()
//                         {
//                             this.count = "";
//                             if ( ! ( isLoaded || dTargetFrame.readyState == "complete" ) ) {
//                                 st( waitForSubmit, 200 );
//                                 this.count ++;
//                             } else if (this.count > 7) {
//                                 return true;
//                                 console.log("skipping dForm");
//                             }
//                             else {
//                                 d.body.removeChild( dForm );
//                                 d.body.removeChild( dTarget );
//                             }
//                         };
//                         st( waitForSubmit, 100 );
//                     }
//                 } else {
//                     console.log('aoCAP property missing');
//                 }
//             }
//         };
//         document.getElementById(formID).addEventListener("submit", function(evt) {
//             //alert('test');
//             evt.preventDefault();
//                 //evaluate radio buttons and post only if checked
//             var radio_btns = document.querySelectorAll("input[type='radio']");
//             for(var i = 0; i < radio_btns.length; i++){
//                 if(radio_btns[i].checked == false){
//                     radio_btns[i].setAttribute("name", "");
//                 };
//             };
//             //evaluate checkboxes and post only if checked
//             var chk_bxs = document.querySelectorAll("input[type='checkbox']");
//             for(var i = 0; i < chk_bxs.length; i++){
//                 if(chk_bxs[i].checked == false){
//                     chk_bxs[i].setAttribute("name", "");
//                 };
//             };
//             //if (formIsValid){
//             console.log("Submitting form!");
//             setTimeout(AoProcessForm(this), 0);
//             setTimeout(function(){
//                 //alert('test');
//                 if(window.location.pathname === "/contact/stay-informed") {
//                     window.location.replace("/contact/newsletter-thank-you")
//                 } else {
//                     window.location.replace("/contact/thank-you");
//                 }
//             }, 1000);
// //                     } else {
// //                         alert("Form invalid. Not submitted");
// //                     }
//         }, true);
//     }

    function initFancyCursor(){
        const cursor = document.querySelector('.fancy-cursor');

        if (window.innerWidth >= 1024) {

            const quickX = gsap.quickTo(cursor, "x", { duration: 0.25, ease: "back.out(4)" });
            const quickY = gsap.quickTo(cursor, "y", { duration: 0.25, ease: "back.out(4)" });
            let mouseExists = false; 
            
            document.addEventListener("mousemove", (e) => {
                quickX(e.clientX);
                quickY(e.clientY);
                if (!mouseExists) {
                    document.querySelector('.fancy-cursor').classList.add('is-active');
                    mouseExists = true; 
                }
            });   
        } 
    }

    function initGeneralAnimations(){

           document.fonts.ready.then(() => { 

            const splitElements = document.querySelectorAll(".scroll-split-in-up");
            splitElements.forEach(element => {
                const split = new SplitText(element, {
                    type: "lines",
                    mask: 'lines'
                });
                gsap.from(split.lines, {
                    scrollTrigger: {
                        trigger: element, 
                        start: "top bottom-=100",
                        toggleActions: "play none none none"
                    },
                    duration: 1,
                    y: 50,
                    autoAlpha: 0,
                    ease: 'power4.out',
                });
            });

            const fadeInElements = document.querySelectorAll(".fade-in");
            fadeInElements.forEach(element => {
                let y = element.dataset.fadeY ? element.dataset.fadeY : 30;
                gsap.from(element, {
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    },
                    duration: 0.5,
                    y: y,
                    autoAlpha: 0,
                    ease: 'slow'
                });
            });

            const slideLeftElements = document.querySelectorAll(".slide-in-left");
            slideLeftElements.forEach(element => {
                gsap.from(element, {
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    },
                    duration: 0.6,
                    x: -50,
                    autoAlpha: 0,
                    ease: 'power2.out'
                });
            });

            const slideRightElements = document.querySelectorAll(".slide-in-right");
            slideRightElements.forEach(element => {
                gsap.from(element, {
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    },
                    duration: 0.6,
                    x: 50,
                    autoAlpha: 0,
                    ease: 'power2.out'
                });
            });

        });

    }

    function initHome(){


        const hero = document.querySelector('.home_hero');
        const modalDialog = document.querySelector('#modal-home-video .modal-dialog');
        

        const video = document.querySelector('#intro-video-bg');
        const isDesktop = window.innerWidth > 550;
        video.src = isDesktop
            ? '/videos/homepage_video_desktop_final.mp4'
            : '/videos/homepage_video_mobile_final.mp4';

        function playHeroVideo() {
            document.querySelector('.home_hero-video-container')?.classList.add('visible');
        }

        video.addEventListener('canplaythrough', playHeroVideo);
        if (video.readyState > 3) playHeroVideo();



        // Hero Video Modal
        const videoAccessibleTrigger = document.querySelector('.home_hero-mobile-video-btn');
        const videoCloseAccessibleTrigger = document.querySelector('#modal-home-video-close');
        const bgVideo = document.querySelector('#intro-video-bg');
        const modalVideo = document.querySelector('#intro-video-modal');
        const videoBSModal = new bootstrap.Modal('#modal-home-video');

        // Add click handler to hero section to open video modal
        if (window.innerWidth >= 1024) {
            hero.addEventListener('click', (e) => {
                if (!e.target.closest('.home_hero-scroll-btn')) {
                    videoBSModal.show();
                }
            });
            modalDialog.addEventListener('click', (e) => {
                videoBSModal.hide();
            });
        }
        // For some reason the button enter event is not working automatically
        videoAccessibleTrigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                videoBSModal.show();
            }
        });
        videoAccessibleTrigger.addEventListener('click', (e) => {
            videoBSModal.show();
        });
        videoCloseAccessibleTrigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                videoBSModal.hide();
            }
        });
        videoCloseAccessibleTrigger.addEventListener('click', (e) => {
            videoBSModal.hide();
        });

        document.getElementById('modal-home-video').addEventListener('hidden.bs.modal', event => {
            if (bgVideo) {
                bgVideo.play();
            }
            if (videoBSModal) {
                modalVideo.pause();
            }
        })

        document.getElementById('modal-home-video').addEventListener('shown.bs.modal', function() {
            if (bgVideo) {
                bgVideo.pause();
            }
            if (modalVideo) {
                modalVideo.currentTime = 0;
                modalVideo.setAttribute('src', '/videos/digital-heart-full.mp4')
                modalVideo.play();
            }
        });


        document.fonts.ready.then(() => {
         
            SplitText.create(".home_hero-text", {
                type: "words",
                mask: 'words',
                onSplit(self) {
                gsap.from(self.words, {
                    duration: 0.38, 
                    y: 50, 
                    autoAlpha: 0, 
                    stagger: 0.025,
                    ease: 'slow',
                    delay: 1
                });
                }
            });
    
            SplitText.create(".home_hero-description", {
                type: "words",
                mask: 'words',
                onSplit(self) {
                gsap.from(self.words, {
                    duration: 0.38, 
                    y: 50, 
                    autoAlpha: 0, 
                    stagger: 0.025,
                    ease: 'slow',
                    delay: 1.25
                });
                }
            });
    
            document.querySelector('.home_hero-text').style.visibility = 'visible';
            document.querySelector('.home_hero-description').style.visibility = 'visible';

        });
        

        if (window.innerWidth < 1024) {
            gsap.from(".home_hero-mobile-video-btn-container", {
                opacity: 0,
                y: 20,
                duration: 0.6,
                delay: 3,
                ease: 'power2.out',
            });
        }

        const scrollBtnArrow = document.querySelector('.home_hero-scroll-btn-arrow');
        const scrollBtnText = document.querySelector('.home_hero-scroll-btn-text');
        //fade in scroll btn
        gsap.from(scrollBtnText, {
            duration: 1,
            autoAlpha: 0,
            y: 20,
            delay: 1.8,
            ease: 'power4.out'
        });
        gsap.from(scrollBtnArrow, {
            duration: 1,
            autoAlpha: 0,
            y: 20,
            delay: 2,
            ease: 'power4.out'
        });


        //SPECIALTIES
        gsap.from(".home_specialties-card", {
            scrollTrigger: {
                trigger: ".home_specialties-cards",
                start: 'top 80%',
                end: 'bottom bottom',
                toggleActions: 'play none none none'
            },
            duration: 0.5,
            y: 30,
            opacity: 0,
            stagger: 0.2,
            ease: "slow"
        });

        gsap.from(".home_specialties-pulse--gradient-bg", {
            scrollTrigger: {
                trigger: ".home_specialties-pulse",
                start: 'top 50%',
                end: 'bottom bottom',
                scrub: 1
            },
            scale: 1.25,
            ease: 'slow'
        });


        //LOGO ROWS
        const logoTween1 = gsap.to(".logo-track--1 .logo-wrapper", {
            duration: 100,
            xPercent: -50,
            ease: 'none',
            repeat: -1,
            force3D: true
        });

        const logoTween2 = gsap.fromTo(".logo-track--2 .logo-wrapper", {
            xPercent: -50,
        },{
            duration: 180,
            xPercent: 0,
            ease: 'none',
            repeat: -1,
            force3D: true
        });

        //OUR WORK SLIDER

        if (window.innerWidth >= 1024) {

            gsap.from(".home_solutions-slider .cycle-carousel-wrap", {
                scrollTrigger: {
                    trigger: ".home_solutions-slider",
                    start: 'top 50%',
                    end: 'bottom bottom',
                    scrub: 1
                },
                marginLeft: '7rem',
                duration: 0.3,
                ease: 'slow'
            });


            const prevSlide = document.querySelector('#prev-slide');
            if (prevSlide) {
                prevSlide.addEventListener('mouseenter', () => {
                    gsap.to('.home_solutions-slider .cycle-carousel-wrap', {
                        marginLeft: '7rem',
                        duration: 0.3,
                        ease: 'power2.out'
                    });
                });
                
                prevSlide.addEventListener('mouseleave', () => {
                    gsap.to('.home_solutions-slider .cycle-carousel-wrap', {
                        marginLeft: '0',
                        duration: 0.3,
                        ease: 'power2.out'
                    });
                });
            }
            const nextSlide = document.querySelector('#next-slide');
            if (nextSlide) {
                nextSlide.addEventListener('mouseenter', () => {
                    gsap.to('.home_solutions-slider .cycle-carousel-wrap', {
                        marginLeft: '-7rem',
                        duration: 0.3,
                        ease: 'power2.out'
                    });
                });
                
                nextSlide.addEventListener('mouseleave', () => {
                    gsap.to('.home_solutions-slider .cycle-carousel-wrap', {
                        marginLeft: '0',
                        duration: 0.3,
                        ease: 'power2.out'
                    });
                });
            }
        }

     


    } // end homepage init

    function initLandingPage(){
        document.fonts.ready.then(() => {

            //Our refreshes within Cycle2 dont seem to work with Safari. Do a second general trigger just in case. 
            let refreshTriggered = false;
            ScrollTrigger.create({
                start: "top+=100vh top",
                onEnter: () => {
                    if (!refreshTriggered) {
                        ScrollTrigger.refresh();
                        refreshTriggered = true;
                    }
                },
                once: true
            });

            //And just in case they scroll really fast, lets just update it one more time lol
            window.setTimeout(() => {
                ScrollTrigger.refresh();
            }, 3000);


            // Hero
            const heroH1 = document.querySelector('h1[data-highlight]');
            if (heroH1) {
                const highlightText = heroH1.getAttribute('data-highlight');
                const headlineText = heroH1.textContent;

                if (highlightText && headlineText.includes(highlightText)) {
                    const wrappedText = headlineText.replace(
                        highlightText, 
                        `<span class="landing-page__header-highlight-container">${highlightText}<span class="landing-page__header-highlight"></span></span>`
                    );
                    heroH1.innerHTML = wrappedText;
                }
            }
            if (document.querySelector('.landing-page__header-highlight')){
                gsap.to(".landing-page__header-highlight", {
                    "--lp-highlight-width": "100%",
                    duration: 0.4,
                    delay: 1.2,
                    ease: "power2.inOut",
                });
            }

            function lpSplitText(selector, delay, stagger){
                document.querySelector(selector).setAttribute('role', 'group');
                SplitText.create(selector, {
                    type: "words",
                    mask: "words",
                    onSplit(self) {
                      gsap.from(self.words, {
                        duration: 1.2,
                        y: 50,
                        autoAlpha: 0,
                        stagger: stagger,
                        ease: "expo.out",
                        delay,
                      });
                    },
                  });
            }
            
            if (document.querySelector('.landing-page__header-headline')){
                lpSplitText('.landing-page__header-headline', 0.6, 0.09);
                document.querySelector('.landing-page__header-headline').style.visibility = 'visible';
            }

            if (document.querySelector('.landing-page__header-description')){
                lpSplitText('.landing-page__header-description', 1.15, 0.03);
                document.querySelector('.landing-page__header-description').style.visibility = 'visible';
            }

            // General text fade-in
            gsap.utils.toArray(".text--fade-in").forEach((el) => {
                el.setAttribute('role', 'group');
                SplitText.create(el, {
                    type: "words",
                    mask: 'words',
                    onSplit(self) {
                    const tween = gsap.from(self.words, {
                        scrollTrigger: {
                            trigger: self.words,
                            start: "top 80%",
                            end: 'top 55%',
                            scrub: true,
                            markers: false
                        },
                        opacity: 0.2,
                        stagger: 0.1
                    });
                    el.style.visibility = 'visible';
                    return tween;
                    }
                });
            });

            //HOME PAGE CONT
            const heroFadeInElements = [
                { selector: ".landing-page__nav-logo", delay: 0.2, y:10 },
                { selector: ".landing-page__nav-contact", delay: 0.3, y:10 },
                { selector: ".landing-page__header-body", delay: 1.7, y:10 },
                { selector: ".landing-page__header-media", delay: 1.9, y:10 },
                { selector: ".landing-page__header-button", delay: 2.2, y:10 },
            ];
          
            heroFadeInElements.forEach(({ selector, delay, y }) => {
                if (document.querySelector(selector)){
                    gsap.from(selector, {
                        opacity: 0,
                        y: y,
                        duration: 0.5, 
                        delay: delay,
                        ease: 'power2.inOut'
                    });
                    document.querySelector(selector).style.visibility = 'visible';
                }
            });

            // Start video playback after GSAP fade-in delay
            const landingPageMediaVideo = document.querySelector(".landing-page__header-media--video");
            if (landingPageMediaVideo) {
                setTimeout(() => {
                    landingPageMediaVideo.play();
                }, 1900); // 1.9 seconds to match GSAP delay
            }

            // Skip the scale zoom for the split hero so the media is never
            // clipped by the header's overflow:hidden — it shows in full.
            const headerMediaInner = document.querySelector(".landing-page__header:not(.landing-page__header--split) .landing-page__header-media-container-inner");
            if (headerMediaInner){
                gsap.from(headerMediaInner, {
                    scrollTrigger: {
                        trigger: headerMediaInner,
                        start: "top 80%",
                        end: 'top 10%',
                        scrub: true,
                        markers: false
                    },
                    scale: 1.3,
                    duration: 0.5,
                    ease: 'slow'
                });
            }

            //COMPONENTS
            gsap.utils.toArray(".heading__line").forEach((el) => {
                gsap.from(el, {
                    scrollTrigger: {
                        trigger: el,
                        start: "top 80%",
                        end: 'top 5%',
                        scrub: true,
                        markers: false
                    },
                    width: 0,
                    opacity: 0,
                    ease: 'power4.out',
                    duration: 1,
                    delay: 0.3
                });
                el.style.visibility = 'visible';
            });

            // Safari cant do transparent videos, swap to fallback
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (isSafari) {
                document.body.classList.add('is-safari');
            }
            document.querySelectorAll('.text-media__video').forEach((video) => {
                if (video.classList.contains('text-media__video--transparent')) {
                    if (isSafari) return;
                    if (video.dataset.src && !video.querySelector('source')) {
                        const source = document.createElement('source');
                        source.src = video.dataset.src;
                        source.type = video.dataset.type || 'video/webm';
                        video.appendChild(source);
                        video.load();
                    }
                }
                videoObserver.observe(video);
            });

            document.querySelectorAll('.media-row__video').forEach((video) => {
                videoObserver.observe(video);
            });

            //TODO - pretty unlikely scenario but could improve this to allow for multiple on the page
            if (document.querySelector('.testimonials-slider')){
                initTestimonialsSlider();
            }

            //Stats count up
            if (document.querySelector(".stats__number-value")){
                gsap.from(".stats__number-value", {
                    scrollTrigger: {
                        trigger: ".stats",
                        start: "top 70%",
                        toggleActions: "play none none none"
                    },
                    innerText: 0,
                    duration: 1,
                    snap: {
                        innerText: 1
                    }
                });
            }

            function staggerIn(items, trigger, stagger, duration) {
                gsap.from(items, {
                    scrollTrigger: {
                        trigger: trigger,
                        start: "top 70%"
                    },
                    opacity: 0,
                    y: 30,
                    stagger: stagger,
                    duration: duration,
                    ease: 'power4.out'
                });
            }
            //Stats staggered fade-in
            if (document.querySelector(".stats__item")){
                staggerIn(".stats__item", ".stats", 0.2, 0.4);
            }
            if (document.querySelector(".icons__content")){
                staggerIn(".icons__content", ".icons", 0.2, 0.6);
            }
            if (document.querySelector(".blogs__no-slider-item")){
                staggerIn(".blogs__no-slider-item", ".blogs__no-slider", 0.2, 0.8);
            }
            // Non-carousel testimonials stagger in as a grid (blocks become a carousel below 768px)
            if (document.querySelector(".testimonials-slider--blocks") && window.matchMedia('(min-width: 768px)').matches){
                staggerIn(".testimonials-slider--blocks .testimonials-slide", ".testimonials-slider--blocks", 0.2, 0.6);
            }
            // Featured case studies stagger in as a grid (featured becomes a carousel below 768px)
            if (document.querySelector(".case-studies__slider-container--featured") && window.matchMedia('(min-width: 768px)').matches){
                staggerIn(".case-studies__slider-container--featured .case-studies__card-link", ".case-studies__slider-container--featured", 0.2, 0.6);
            }
            // Half-width text/media images stagger their opacity in, scoped per row so multiple half-rows each trigger independently
            gsap.utils.toArray(".landing-page__halves").forEach((halves) => {
                const halfImages = halves.querySelectorAll(".text-media--half .text-media__img, .text-media--half .text-media__video");
                if (!halfImages.length) return;
                gsap.from(halfImages, {
                    scrollTrigger: {
                        trigger: halves,
                        start: "top 70%"
                    },
                    opacity: 0,
                    stagger: 0.2,
                    duration: 0.6,
                    ease: 'power4.out'
                });
            });

            //Logo Roll
            if (document.querySelector(".logo-roll__track")){
                const logoRollTween = gsap.fromTo(".logo-roll__track .logo-roll__wrapper", {
                    xPercent: -50,
                },{
                    duration: 180,
                    xPercent: 0,
                    ease: 'none',
                    repeat: -1,
                    force3D: true
                });
            }

            //Slight parallax on images
            gsap.utils.toArray(".text-media--parallax").forEach((el) => {
                const parallaxDirection = el.getAttribute('data-parallax-direction');
                const yPercent = parallaxDirection === 'up' ? -14 : 14;
                gsap.to(el, {
                    yPercent: yPercent,
                    transformOrigin: 'center center',
                    ease: "none",
                    scrollTrigger: {
                        trigger: el,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                    },
                });
            });

            gsap.utils.toArray(".text-media__blob").forEach((blob) => {
                const row = blob.closest(".text-media");
                if (!row) return;
                gsap.set(blob, { xPercent: -50, transformOrigin: "50% 100%" });
                gsap.to(blob, {
                    scale: () => Math.max(row.offsetWidth / blob.offsetWidth, row.offsetHeight / blob.offsetHeight) * 1.15,
                    ease: "none",
                    scrollTrigger: {
                        trigger: row,
                        start: "top center",
                        end: "bottom top",
                        scrub: true,
                        invalidateOnRefresh: true,
                    },
                });
            });

        }); 
    } 

    function initHolidayInteractive(){
        let scene = document.querySelector('.holiday-interactive__scene > svg');

        if (scene) {

            //----------------------------
            // DRAGGABLE

            // Function to adjust scene sizing based on container vs window height
            let sceneDraggable = null;
            let isPanMode = false;
            const container = document.querySelector('.holiday-interactive__scene');
            const page = document.querySelector('.holiday-interactive');
            let isMobileLandscape = false;

            function adjustSceneSizing() {
                setTimeout(() => {
                    requestAnimationFrame(() => {
       
                        if (!page || !container) return;
                        const svg = document.querySelector('.holiday-interactive__scene > svg');
                        const pageHeight = page.offsetHeight;
                        const pageWidth = page.offsetWidth;
                        const containerHeight = container.offsetHeight;
                        const containerWidth = container.offsetWidth;


                        //If mobile landscape, show modal asking user to go to mobile portrait
                        const widthToHeightRatio = pageWidth / pageHeight;
                        if (pageWidth < 1024 && widthToHeightRatio > 1.5) {
                            isMobileLandscape = true;
                            showMobileLandscapeModal();
                        } else if (isMobileLandscape) {
                            // Hide modal if user rotated back to portrait.   
                            isMobileLandscape = false;
                            hideMobileLandscapeModal();
                            //Re-toggle active window if there is one
                            let activeWindow = document.querySelector('.holiday-interactive__window[data-active="true"]');
                            if (activeWindow) {
                                activeWindow.dispatchEvent(new MouseEvent('click'));
                                setTimeout(() => {
                                    activeWindow.dispatchEvent(new MouseEvent('click'));
                                }, 100);
                            } 
                        } else {
                            isMobileLandscape = false;
                        }

                        if (containerHeight < pageHeight && !isPanMode) {

                            console.log("pan-mode");
                            isPanMode = true;
                            // Enable pan mode
                            page.classList.add('holiday-interactive--pan-mode');

                            // Kill previous Draggable if it exists
                            if (sceneDraggable) {
                                sceneDraggable.kill();
                            }

                            // Create new Draggable
                            sceneDraggable = Draggable.create(container, {
                                type: 'x,y',
                                edgeResistance: 1,
                                inertia: true,
                                bounds: page,
                                minimumMovement: 10,
                                allowNativeTouchScrolling: false,
                                cursor: 'grab',
                                onPress() { this.cursor = 'grabbing'; },
                                onRelease() { this.cursor = 'grab'; }
                            })[0]; // Draggable.create returns an array

                            //recenter scene
                            const containerRect = container.getBoundingClientRect();
                            const viewportRect = page.getBoundingClientRect();
                            const offsetX = (viewportRect.width - containerRect.width) / 2;
                            const offsetY = (viewportRect.height - containerRect.height) / 2;
                            gsap.set(container, { x: offsetX, y: offsetY });

                        }
                        else if (pageWidth > 2000 && pageHeight < 1500) {
                            console.log("default mode");
                            isPanMode = false;
                            // Default mode, kill Draggable
                            page.classList.remove('holiday-interactive--pan-mode');
                            if (sceneDraggable) {
                                sceneDraggable.kill();
                                sceneDraggable = null;
                            }
                        }
                        else if (isPanMode) {
                            //recenter scene 
                            const containerRect = container.getBoundingClientRect();
                            const viewportRect = page.getBoundingClientRect();
                            const offsetX = (viewportRect.width - containerRect.width) / 2;
                            const offsetY = (viewportRect.height - containerRect.height) / 2;
                            gsap.set(container, { x: offsetX, y: offsetY });
                        }
                    });
                }, 100);
            }

            // Call on load
            adjustSceneSizing();

            // Call on resize
            const debouncedAdjustSceneSizing = _.debounce(adjustSceneSizing, 200);
            window.addEventListener('resize', debouncedAdjustSceneSizing);


            //----------------------------
            // MOBILE LANDSCAPE MODAL - Show when user is in landscape mode on mobile
            
            const mobileLandscapeModal = document.getElementById('mobileLandscapeModal');
            
            // Initialize modal as inactive
            if (mobileLandscapeModal) {
                mobileLandscapeModal.dataset.active = 'false';
            }
            
            function showMobileLandscapeModal() {
                if (mobileLandscapeModal) {
                    mobileLandscapeModal.dataset.active = 'true';
                }
            }
            
            function hideMobileLandscapeModal() {
                if (mobileLandscapeModal) {
                    mobileLandscapeModal.dataset.active = 'false';
                }
            }
            
            function checkMobileLandscape() {
                const page = document.querySelector('.holiday-interactive');
                if (!page) return;
                
                const pageWidth = page.offsetWidth;
                const pageHeight = page.offsetHeight;
                const widthToHeightRatio = pageWidth / pageHeight;
                if (pageWidth < 1024 && widthToHeightRatio > 1.5) {
                    showMobileLandscapeModal();
                } else {
                    hideMobileLandscapeModal();
                }
            }
            
            // Check on page load
            checkMobileLandscape();
            
            // Check on resize and orientation change
            window.addEventListener('resize', () => {
                checkMobileLandscape();
            });
            window.addEventListener('orientationchange', () => {
                setTimeout(() => {
                    checkMobileLandscape();
                }, 100);
            });

            //----------------------------
            // SETUP

            let officeWindows = scene.querySelectorAll('#Windows [id^="full-window"]');
            let people = document.querySelectorAll('.holiday-interactive__person-data');
            let quickTipContainer = document.querySelector('.holiday-interactive__quick-tip-container');
            let personHeight = null;
            let clickedWindows = new Set();
            let isZoomedIn = false;
            let hasShownQuickTip = false;
            let panModeIsFirstWindowLoad = true;

            if (officeWindows.length > 0) {
                officeWindows.forEach((window, index) => {
                    let person = people[index];
                    if (person) {
                        //Add the data theme
                        window.setAttribute('data-theme', person.dataset.theme);
                        // Find the existing image element for this person
                        let personImage = person.querySelector('.holiday-interactive__person-image');
                        if (personImage) {
                            let imageUrl = personImage.getAttribute('src');
                            if (imageUrl) {
                                
                                let windowPerson = window.querySelector('[id^="window-person"]');
                                let windowShadow = window.querySelector('[id^="window-person-shadow"]');
                                
                                if (windowPerson && windowShadow) {
                                    // Get the bounding box of the window-person group
                                    let bbox = windowPerson.getBBox();
                                    personHeight = personHeight === null ? bbox.height : personHeight;
                                    // Ensure defs element exists in the SVG
                                    let defs = scene.querySelector('defs');
                                    if (!defs) {
                                        defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
                                        scene.insertBefore(defs, scene.firstChild);
                                    }
                                    
                                    // Create unique clipPath ID for this person
                                    let clipPathId = `person-clip-${index}`;
                                    let shadowClipPathId = `shadow-clip-${index}`;
                                    
                                    // Create clipPath element
                                    let clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
                                    clipPath.setAttribute('id', clipPathId);
                                    
                                    // Create rect for the clipPath using the bounding box
                                    let clipRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
                                    clipRect.setAttribute('x', bbox.x);
                                    clipRect.setAttribute('y', bbox.y);
                                    clipRect.setAttribute('width', bbox.width);
                                    clipRect.setAttribute('height', bbox.height);
                                    
                                    // Append rect to clipPath and clipPath to defs
                                    clipPath.appendChild(clipRect);
                                    defs.appendChild(clipPath);
                                    
                                    // Apply clip-path to the windowPerson group
                                    windowPerson.setAttribute('clip-path', `url(#${clipPathId})`);
                                    
                                    // Create SVG image element using the same image src
                                    // Make image 20% wider and taller than bounding box, bottom-aligned vertically
                                    let imageWidth = bbox.width * 1.2;
                                    let imageHeight = bbox.height * 1.2;
                                    let imageX = bbox.x - (imageWidth - bbox.width) / 2;
                                    let imageY = bbox.y + bbox.height - imageHeight;
                                    
                                    let svgImage = document.createElementNS('http://www.w3.org/2000/svg', 'image');
                                    svgImage.setAttributeNS('http://www.w3.org/1999/xlink', 'href', imageUrl);
                                    svgImage.setAttribute('x', imageX);
                                    svgImage.setAttribute('y', imageY);
                                    svgImage.setAttribute('width', imageWidth);
                                    svgImage.setAttribute('height', imageHeight);
                                    svgImage.setAttribute('preserveAspectRatio', 'xMidYMid slice');
                                    svgImage.setAttribute('class', 'holiday-interactive__window-person-image');
                                    
                                    // Append the image inside the windowPerson group
                                    windowPerson.appendChild(svgImage);

                                    // Get the bounding box of the window-shadow group
                                    let shadowBbox = windowShadow.getBBox();
                                    
                                    // Create clipPath element for shadow
                                    let shadowClipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
                                    shadowClipPath.setAttribute('id', shadowClipPathId);
                                    
                                    // Create rect for the shadow clipPath using the shadow bounding box
                                    let shadowClipRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
                                    shadowClipRect.setAttribute('x', shadowBbox.x);
                                    shadowClipRect.setAttribute('y', shadowBbox.y);
                                    shadowClipRect.setAttribute('width', shadowBbox.width);
                                    shadowClipRect.setAttribute('height', shadowBbox.height);
                                    
                                    // Append rect to shadow clipPath and shadow clipPath to defs
                                    shadowClipPath.appendChild(shadowClipRect);
                                    defs.appendChild(shadowClipPath);
                                    
                                    // Apply clip-path to the windowShadow group
                                    windowShadow.setAttribute('clip-path', `url(#${shadowClipPathId})`);
                                    
                                    // Create SVG image element using the existing image src
                                    // Make image 20% wider and taller than bounding box, bottom-aligned vertically
                                    let shadowImageWidth = shadowBbox.width * 1.2;
                                    let shadowImageHeight = shadowBbox.height * 1.2;
                                    let shadowImageX = shadowBbox.x - (shadowImageWidth - shadowBbox.width) / 2;
                                    let shadowImageY = shadowBbox.y + shadowBbox.height - shadowImageHeight;
                                    
                                    let shadowSvgImage = document.createElementNS('http://www.w3.org/2000/svg', 'image');
                                    shadowSvgImage.setAttributeNS('http://www.w3.org/1999/xlink', 'href', imageUrl);
                                    shadowSvgImage.setAttribute('x', shadowImageX);
                                    shadowSvgImage.setAttribute('y', shadowImageY);
                                    shadowSvgImage.setAttribute('width', shadowImageWidth);
                                    shadowSvgImage.setAttribute('height', shadowImageHeight);
                                    shadowSvgImage.setAttribute('preserveAspectRatio', 'xMidYMid slice');
                                    shadowSvgImage.setAttribute('class', 'holiday-interactive__window-person-shadow-image');
                                    
                                    // Insert the image as the first child of the windowShadow group
                                    windowShadow.insertBefore(shadowSvgImage, windowShadow.firstChild);

                                    // Add class to window for hover targeting
                                    window.setAttribute('class', 'holiday-interactive__window');
                                }
                            }
                        }
                    }
                });
            }
    
            function showQuickTip(messageTopOffset, messageLeftOffset, messageWidth, messageHeight){
                if (quickTipContainer) {
                    requestAnimationFrame(() => {
                        let quickTipWidth = quickTipContainer.getBoundingClientRect().width;
                        let quickTipTopOffset = messageTopOffset + messageHeight + 40;
                        // let quickTipLeftOffset = messageLeftOffset + (messageWidth / 2) - (quickTipWidth / 2);
                        let quickTipLeftOffset = messageLeftOffset + 30;
                        
                        // Don't go off the right side
                        if (quickTipLeftOffset + quickTipWidth > window.innerWidth - 15) {
                            quickTipLeftOffset = window.innerWidth - quickTipWidth - 15;
                        }
                        
                        quickTipContainer.style.top = `${quickTipTopOffset}px`;
                        quickTipContainer.style.left = `${quickTipLeftOffset}px`;

                        setTimeout(() => {
                            quickTipContainer.dataset.active = 'true';
                            setTimeout(() => {
                                quickTipContainer.dataset.active = 'false';
                            }, 15000);
                        }, 200);
                        
                        
                    });
                }
            }

            function toggleWindow(index, action = 'toggle'){
                let officeWindow = officeWindows[index];
                if (!officeWindow) return;
                
                //CLOSE WINDOW
                if (action === 'close' || (action === 'toggle' && officeWindow.dataset.active === 'true')){
                    officeWindow.dataset.active = false;
                    let person = people[officeWindow.dataset.windowIndex];
                    if (person) {
                        person.dataset.active = false;
                        let nameplate = person.querySelector('.holiday-interactive__nameplate');
                        if (nameplate) nameplate.dataset.active = false;
                        let message = person.querySelector('.holiday-interactive__message');
                        if (message) message.dataset.active = false;
                    }
                    
                    // Close quick tip if it's open
                    if (quickTipContainer && quickTipContainer.dataset.active === 'true') {
                        quickTipContainer.dataset.active = 'false';
                    }
                    
                    // Check if all windows have been opened and this is the last one being closed
                    if (clickedWindows.size === officeWindows.length) {
                        // Check if this was the last open window
                        let anyWindowOpen = Array.from(officeWindows).some(window => window.dataset.active === 'true');
                        if (!anyWindowOpen) {
                            // All windows clicked and all are now closed - show outro modal
                            setTimeout(() => {
                                showThankYouModal();
                                clickedWindows.clear();
                            }, 300);
                        }
                    }
                } else {
                //OPEN WINDOW
                    officeWindow.dataset.active = true;
                    clickedWindows.add(index);
                    
                    let person = people[officeWindow.dataset.windowIndex];
                    if (person) {

                        function positionNameplateAndMessage() {
                            let nameplate = person.querySelector('.holiday-interactive__nameplate');
                            let message = person.querySelector('.holiday-interactive__message');
                            person.dataset.active = true;

                            requestAnimationFrame(() => {
                                let rect = officeWindow.getBoundingClientRect();
                                let scrollY = window.scrollY || window.pageYOffset;
                                let scrollX = window.scrollX || window.pageXOffset;
                                
                                let topPos = rect.top + scrollY;
                                let leftPos = rect.left + scrollX;
                                let officeWindowHeight = rect.height;
                                let officeWindowWidth = rect.width;
                                
                                if (nameplate) {
                                    nameplate.dataset.active = true;
                                    let nameplateWidth = nameplate.getBoundingClientRect().width;
                                    if (isPanMode) {
                                        //Position it with CSS
                                        // nameplate.style.top = `${topPos + officeWindowHeight}px`;
                                        // nameplate.style.left = `${leftPos + officeWindowWidth / 2 - nameplateWidth / 2}px`;
                                    } else {
                                        nameplate.style.top = `${topPos + officeWindowHeight}px`;
                                        nameplate.style.left = `${leftPos + officeWindowWidth / 2 - nameplateWidth / 2}px`;
                                    }
                                }
                                
                                
                                if (message) {
                                    message.dataset.active = true;
                                    let messageWidth = message.getBoundingClientRect().width;
                                    let messageHeight = message.getBoundingClientRect().height;
                                    let messageTopOffset = topPos - messageHeight * 0.7;
                                    //Dont go off the top
                                    if (messageTopOffset < 15) {
                                        messageTopOffset = 15;
                                    }
                                    //If message is going off right side, move it to the left
                                    let messageLeftOffset = leftPos + officeWindowWidth + 20;
                                    if (messageLeftOffset > window.innerWidth - (messageWidth * 1.25)) {
                                        messageLeftOffset = leftPos - messageWidth - 20;
                                        message.dataset.side = 'left';
                                    } else {
                                        message.dataset.side = 'right';
                                    }
                                    if (isPanMode) {
                                        //Position it with CSS
                                        // message.style.top = `${topPos - messageHeight}px`;
                                        // message.style.left = `${leftPos + officeWindowWidth / 2 - messageWidth / 2}px`;
                                        
                                    } else {
                                        message.style.top = `${messageTopOffset}px`;
                                        message.style.left = `${messageLeftOffset}px`;
                                    }
                                    
                                    // Show quick tip when third window opens (but not in pan mode) and only once
                                    if (clickedWindows.size === 3 && !isPanMode && !hasShownQuickTip) {
                                        showQuickTip(messageTopOffset, messageLeftOffset, messageWidth, messageHeight);
                                        hasShownQuickTip = true;
                                    }
                                }
                            });
                        }
                        
                        
                        

                        //On Pan-mode, center on the person being clicked before opening the window
                        if (isPanMode && container && page) {

                            function centerOnPerson() {
                                //First, if the zoom has not happened, re-zoom
                                //Check if the person is 40vh and zoom in if not 
                                // Calculate scale to zoom in so that a window is 40vh
                            
                                const currentScale = gsap.getProperty(container, "scale") || 1;
                                const targetHeight = (window.visualViewport?.height || window.innerHeight) * 0.4; 
                                const zoomScale = targetHeight / personHeight;
                                if (currentScale !== zoomScale) {
                                    gsap.to(container, {
                                        scale: zoomScale,
                                        duration: 0.6,
                                        ease: "power2.out"
                                    });
                                    isZoomedIn = true;
                                } else {
                                    isZoomedIn = true; 
                                }
                                updateZoomButtonStates();

                                // Get the person's (officeWindow) bounding box relative to the viewport
                                const personRect = officeWindow.getBoundingClientRect();
                                const pageRect = page.getBoundingClientRect();
                                
                                // Calculate person's center point in viewport coordinates
                                const personCenterX = personRect.left + personRect.width / 2;
                                const personCenterY = personRect.top + personRect.height / 2;
                                
                                // Get viewport center
                                const viewportCenterX = pageRect.left + pageRect.width / 2;
                                const viewportCenterY = pageRect.top + pageRect.height / 2;
                                
                                // Calculate the delta needed to move the person to the center
                                const deltaX = viewportCenterX - personCenterX;
                                const deltaY = viewportCenterY - personCenterY;
                                
                                // Get current GSAP transform values (default to 0 if not set)
                                const currentX = gsap.getProperty(container, "x") || 0;
                                const currentY = gsap.getProperty(container, "y") || 0;

                                //Add in a vertical offset so they're actually a bit below center
                                //Go down 8vh, add extra on iOS
                                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.maxTouchPoints && navigator.platform === 'MacIntel');
                                const isMobile = window.innerWidth < 768;
                                const mobileOffset = isIOS && isMobile ? 0.20 : 0.12;
                                const verticalOffset = (window.visualViewport?.height || window.innerHeight) * mobileOffset;
                                
                                
                                // Calculate new container position by adding the delta to current position
                                const offsetX = currentX + deltaX;
                                const offsetY = currentY + deltaY + verticalOffset;

                                // Animate to center on the person
                                gsap.to(container, { 
                                    x: offsetX, 
                                    y: offsetY, 
                                    duration: 0.6, 
                                    ease: "power2.out",
                                    onComplete: () => {
                                        setTimeout(() => {
                                            positionNameplateAndMessage();
                                        }, 10);
                                    }
                                });
                            }

                            //If the very first window on the intro, wait for animation frames to catch up
                            //Otherwise centering gets wrong dimensions
                            if (clickedWindows.size === 1 && panModeIsFirstWindowLoad) {
                                requestAnimationFrame(() => {
                                    requestAnimationFrame(() => {
                                        panModeIsFirstWindowLoad = false;
                                        centerOnPerson();
                                    });
                                });
                            } else {
                                centerOnPerson();
                            }
                        }
                        else {
                            positionNameplateAndMessage();
                        }
                    }
                }
            }
    
            officeWindows.forEach((officeWindow, index) => {
                //Grab the equivalent person in order
                officeWindow.dataset.windowIndex = index;
                
                // Track if touch event was handled to prevent double-firing with click
                let touchHandled = false;
                
                // Unified handler for both mouse clicks and touch events
                const handleWindowInteraction = (e) => {
                    // Skip click event if touch was already handled
                    if (e.type === 'click' && touchHandled) {
                        touchHandled = false;
                        return;
                    }
                    
                    // Mark touch as handled and prevent click from firing
                    if (e.type === 'touchend') {
                        touchHandled = true;
                        e.preventDefault(); // Prevent click event from firing
                    }
                    
                    let windowIsOpen = false;
                    officeWindows.forEach(window => {
                        if (window.dataset.active === 'true') {
                            windowIsOpen = true;
                        }
                        toggleWindow(window.dataset.windowIndex, 'close');
                    });
                    
                    // Get the window index from the event target
                    let targetWindow = e.target.closest('[id^="full-window"]');
                    let index = targetWindow?.dataset.windowIndex;
                    
                    if (windowIsOpen) {
                        return;
                    } else {
                        // If zoomed out, zoom in first, then open the window
                        if (isPanMode && !isZoomedIn) {
                            const targetHeight = (window.visualViewport?.height || window.innerHeight) * 0.4;
                            const zoomScale = targetHeight / personHeight;
                            
                            gsap.to(container, {
                                scale: zoomScale,
                                duration: 0.6,
                                ease: "power2.out",
                                onComplete: () => {
                                    isZoomedIn = true;
                                    updateZoomButtonStates();
                                    requestAnimationFrame(() => {
                                        toggleWindow(index, 'open');
                                    });
                                }
                            });
                        } else {
                            requestAnimationFrame(() => {
                                toggleWindow(index, 'open');
                            });
                        }
                    }
                };
                
                // Add both click and touchend listeners for cross-platform compatibility
                officeWindow.addEventListener('click', handleWindowInteraction);
                officeWindow.addEventListener('touchend', handleWindowInteraction, { passive: false });
            });
    
            // Handle close button clicks
            document.querySelectorAll('.holiday-interactive__message-close').forEach(closeBtn => {
                closeBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    let message = closeBtn.closest('.holiday-interactive__message');
                    if (message) {
                        let personIndex = message.dataset.personIndex;
                        toggleWindow(parseInt(personIndex), 'close');
                    }
                });
            });
    
            //De-activate windows when clicking outside of them and their associated content
            document.addEventListener('click', (e) => {
                let activeOfficeWindow = Array.from(officeWindows).find(window => window.dataset.active === 'true');
                if (activeOfficeWindow) {
                    let clickedWithinOfficeWindow = activeOfficeWindow.contains(e.target);
                    let activePerson = people[activeOfficeWindow.dataset.windowIndex];
                    let activeNameplate = activePerson ? activePerson.querySelector('.holiday-interactive__nameplate') : null;
                    let activeMessage = activePerson ? activePerson.querySelector('.holiday-interactive__message') : null;
                    let clickedWithinNameplate = activeNameplate && activeNameplate.contains(e.target);
                    let clickedWithinMessage = activeMessage && activeMessage.contains(e.target);
                    
                    // If click is outside the officeWindow, nameplate, and message, deactivate
                    if (!clickedWithinOfficeWindow && !clickedWithinNameplate && !clickedWithinMessage) {
                        toggleWindow(activeOfficeWindow.dataset.windowIndex, 'close');
                    }
                }
            });
    
            // Keyboard navigation - Left/Right arrow keys and Tab/Shift+Tab to navigate between windows
            document.addEventListener('keydown', (e) => {
                // Don't interfere with Escape key handlers for modals
                if (e.key === 'Escape') {
                    return;
                }
            
                const welcomeModal = document.getElementById('welcomeModal');
                const thankYouModal = document.getElementById('thankYouModal');
                const mobileLandscapeModal = document.getElementById('mobileLandscapeModal');
                if ((welcomeModal && welcomeModal.dataset.active === 'true') || 
                    (thankYouModal && thankYouModal.dataset.active === 'true') ||
                    (mobileLandscapeModal && mobileLandscapeModal.dataset.active === 'true')) {
                    return;
                }
                
                let direction = null;
                if (e.key === 'ArrowRight' || (e.key === 'Tab' && !e.shiftKey)) {
                    direction = 'right';
                } else if (e.key === 'ArrowLeft' || (e.key === 'Tab' && e.shiftKey)) {
                    direction = 'left';
                }

                if (!direction) {
                    return;
                }
    
                const quickTipContainer = document.querySelector('.holiday-interactive__quick-tip-container');
                if (quickTipContainer) {
                    quickTipContainer.dataset.active = 'false';
                }
            
                if (e.key === 'Tab') {
                    e.preventDefault();
                }
                
                let activeOfficeWindow = Array.from(officeWindows).find(window => window.dataset.active === 'true');
                if (!activeOfficeWindow) {
                    if (direction === 'right' && officeWindows.length > 0) {
                        toggleWindow(0, 'open');
                    } else if (direction === 'left' && officeWindows.length > 0) {
                        toggleWindow(officeWindows.length - 1, 'open');
                    }
                    return;
                }

                let currentIndex = parseInt(activeOfficeWindow.dataset.windowIndex);
                let nextIndex;
                if (direction === 'right') {
                    nextIndex = (currentIndex + 1) % officeWindows.length;
                } else if (direction === 'left') {
                    nextIndex = (currentIndex - 1 + officeWindows.length) % officeWindows.length;
                }
                
                // Close current window and open next window
                if (nextIndex !== undefined && nextIndex !== currentIndex) {
                    toggleWindow(currentIndex, 'close');
                    // Small delay to ensure close animation completes before opening next
                    setTimeout(() => {
                        toggleWindow(nextIndex, 'open');
                    }, 50);
                }
            });


            //----------------------------
            // WELCOME MODAL
 
            const welcomeModal = document.getElementById('welcomeModal');
            const welcomeModalOverlay = welcomeModal?.querySelector('.holiday-interactive__modal-overlay');
            const welcomeModalContent = welcomeModal?.querySelector('.holiday-interactive__modal-content');
            const welcomeModalClose = welcomeModal?.querySelector('.holiday-interactive__modal-close');
            
            function closeWelcomeModal() {
                welcomeModal.dataset.active = 'false';
                setTimeout(() => {
                    if (welcomeModal.dataset.active === 'false') {

                        if (isPanMode) {
                            // Calculate scale to zoom in so that a window is 40vh
                            const targetHeight = (window.visualViewport?.height || window.innerHeight) * 0.4;
                            const zoomScale = targetHeight / personHeight;

                            const scene = document.querySelector('.holiday-interactive__scene > svg');
                            const officeWindows = scene.querySelectorAll('#Windows [id^="full-window"]');
                            const firstWindow = officeWindows[0];
                            
                            gsap.to(container, {
                                scale: zoomScale,
                                duration: 0.6,
                                ease: "power2.out",
                                onComplete: () => {
                                    setTimeout(() => {
                                        firstWindow.dispatchEvent(new MouseEvent('click'));
                                    }, 100);
                                }
                            });
                            
                            isZoomedIn = true;
                            updateZoomButtonStates();

                        }
                        else {
                            // Scroll up smoothly, then click the first window
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                            
                            // Wait for scroll to complete, then click first window
                            setTimeout(() => {
                                const scene = document.querySelector('.holiday-interactive__scene > svg');
                                const officeWindows = scene.querySelectorAll('#Windows [id^="full-window"]');
                                const firstWindow = officeWindows[0];
                                if (firstWindow) {
                                    firstWindow.dispatchEvent(new MouseEvent('click'));
                                }
                            }, 150); 

                        }
                        
                      
                    }
                }, 500);
            }
        
            if (welcomeModal) {
                welcomeModal.dataset.active = 'true';
                if (welcomeModalOverlay) {
                    welcomeModalOverlay.addEventListener('click', (e) => {
                        if (e.target === welcomeModalOverlay) {
                            closeWelcomeModal();
                        }
                    });
                }
                if (welcomeModalContent) {
                    welcomeModalContent.addEventListener('click', (e) => {
                        e.stopPropagation();
                    });
                }
                if (welcomeModalClose) {
                    welcomeModalClose.addEventListener('click', closeWelcomeModal);
                }
                const welcomeModalButton = document.getElementById('welcomeModalButton');
                if (welcomeModalButton) {
                    welcomeModalButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        closeWelcomeModal();
                    });
                }
                document.addEventListener('keydown', (e) => {
                    if (e.key === 'Escape' && welcomeModal.dataset.active === 'true') {
                        closeWelcomeModal();
                    }
                });
            }


            //----------------------------
            // THANK YOU MODAL - Show when all windows have been clicked and final window is closed
            

            // Setup Thank You Modal event listeners
            const thankYouModal = document.getElementById('thankYouModal');
            const thankYouModalOverlay = thankYouModal?.querySelector('.holiday-interactive__modal-overlay');
            const thankYouModalContent = thankYouModal?.querySelector('.holiday-interactive__modal-content');
            const thankYouModalClose = thankYouModal?.querySelector('.holiday-interactive__modal-close');

            function showThankYouModal() {
                thankYouModal.dataset.active = 'true';
            }

            function closeThankYouModal() {
                //Just reload the whole page 
                window.location.reload();
            }
            
            if (thankYouModal) {
                thankYouModal.dataset.active = 'false';
                
                if (thankYouModalOverlay) {
                    thankYouModalOverlay.addEventListener('click', (e) => {
                        if (e.target === thankYouModalOverlay) {
                            closeThankYouModal();
                        }
                    });
                }
                if (thankYouModalContent) {
                    thankYouModalContent.addEventListener('click', (e) => {
                        e.stopPropagation();
                    });
                }
                if (thankYouModalClose) {
                    //dont reload, let them explore
                    thankYouModalClose.addEventListener('click', function(){
                        thankYouModal.dataset.active = 'false';
                    });
                }
                const thankYouModalButton = document.getElementById('thankYouModalButton');
                if (thankYouModalButton) {
                    thankYouModalButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        closeThankYouModal();
                    
                    });
                }
                document.addEventListener('keydown', (e) => {
                    if (e.key === 'Escape' && thankYouModal.dataset.active === 'true') {
                        closeThankYouModal();
                    }
                });
            }
   

            //----------------------------
            // ZOOM BUTTONS
            const zoomInButton = document.querySelector('.holiday-interactive__zoom-button[aria-label="Zoom in"]');
            const zoomOutButton = document.querySelector('.holiday-interactive__zoom-button[aria-label="Zoom out"]');

            function updateZoomButtonStates() {
                if (zoomInButton) {
                    if (isZoomedIn) {
                        zoomInButton.dataset.disabled = 'true';
                    } else {
                        zoomInButton.dataset.disabled = 'false';
                    }
                }
                if (zoomOutButton) {
                    if (!isZoomedIn) {
                        zoomOutButton.dataset.disabled = 'true';
                    } else {
                        zoomOutButton.dataset.disabled = 'false';
                    }
                }
            }

            function zoomIn() {
                if (!isPanMode || !container || !personHeight) return;
                if (isZoomedIn) return; // Already zoomed in
                
                const targetHeight = (window.visualViewport?.height || window.innerHeight) * 0.4;
                const zoomScale = targetHeight / personHeight;

                console.log("window full height", window.visualViewport?.height || window.innerHeight);
                console.log("person height", personHeight);
                console.log("zoom scale", zoomScale);
                console.log("target height", targetHeight);
                
                gsap.to(container, {
                    scale: zoomScale,
                    duration: 0.6,
                    ease: "power2.out"
                });
                
                isZoomedIn = true;
                updateZoomButtonStates();
            }

            function zoomOut() {
                if (!isPanMode || !container || !page) return;
                if (!isZoomedIn) return; // Already zoomed out
                
                // Calculate center position based on container's natural size (at scale 1)
                const containerWidth = container.offsetWidth;
                const containerHeight = container.offsetHeight;
                const viewportRect = page.getBoundingClientRect();
                const offsetX = (viewportRect.width - containerWidth) / 2;
                const offsetY = (viewportRect.height - containerHeight) / 2;
                
                gsap.to(container, {
                    scale: 1,
                    x: offsetX,
                    y: offsetY,
                    duration: 0.6,
                    ease: "power2.out"
                });
                
                isZoomedIn = false;
                updateZoomButtonStates();
            }

            if (zoomInButton) {
                zoomInButton.addEventListener('click', (e) => {
                    if (zoomInButton.dataset.disabled === 'true') {
                        e.preventDefault();
                        return;
                    }
                    zoomIn();
                });
            }

            if (zoomOutButton) {
                zoomOutButton.addEventListener('click', (e) => {
                    if (zoomOutButton.dataset.disabled === 'true') {
                        e.preventDefault();
                        return;
                    }
                    zoomOut();
                });
            }

            // Initialize button states
            updateZoomButtonStates();

            //----------------------------
            // MOBILE NAVIGATION
            const mobilePreviousWindows = document.querySelectorAll('.holiday-interactive__mobile-previous-window');
            const mobileNextWindows = document.querySelectorAll('.holiday-interactive__mobile-next-window');
            
            // Function to navigate between windows
            function navigateWindows(direction) {
          
                // Find the currently active window
                let activeOfficeWindow = Array.from(officeWindows).find(window => window.dataset.active === 'true');
                let currentIndex = parseInt(activeOfficeWindow.dataset.windowIndex);
                let nextIndex;
                
                // Calculate next index based on direction
                if (direction === 'right') {
                    nextIndex = (currentIndex + 1) % officeWindows.length;
                } else if (direction === 'left') {
                    nextIndex = (currentIndex - 1 + officeWindows.length) % officeWindows.length;
                }
                
                // Close current window and open next window
                if (nextIndex !== undefined && nextIndex !== currentIndex) {
                    toggleWindow(currentIndex, 'close');
                    setTimeout(() => {
                        toggleWindow(nextIndex, 'open');
                    }, 50);
                }
            }
            
            // Add event listeners to all previous window buttons
            mobilePreviousWindows.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.stopPropagation(); // Prevent triggering window close
                    navigateWindows('left');
                });
            });
            
            // Add event listeners to all next window buttons
            mobileNextWindows.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.stopPropagation(); // Prevent triggering window close
                    navigateWindows('right');
                });
            });
            


            //----------------------------
            // FRONT DOOR 
            const behindTheDoorPath = scene.querySelector('#behind-the-door');
            if (behindTheDoorPath) {
                // Get the image URL from the rendered image element
                const petImage = document.querySelector('.holiday-interactive__pet-image');
                if (petImage) {
                    const imageUrl = petImage.getAttribute('src');
                    if (imageUrl) {
                        // Get the bounding box of the path
                        const bbox = behindTheDoorPath.getBBox();
                        
                        // Create a group element
                        const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                        group.setAttribute('id', 'behind-the-door');
                        
                        // Create the image element
                        const image = document.createElementNS('http://www.w3.org/2000/svg', 'image');
                        image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', imageUrl);
                        image.setAttribute('x', bbox.x);
                        image.setAttribute('y', bbox.y);
                        image.setAttribute('width', bbox.width);
                        image.setAttribute('height', bbox.height);
                        
                        // Insert the group before the path
                        const parent = behindTheDoorPath.parentNode;
                        parent.insertBefore(group, behindTheDoorPath);
                        
                        // Move the path into the group
                        group.appendChild(behindTheDoorPath);
                        
                        // Add the image to the group (after the path so it's in front)
                        group.appendChild(image);
                    }
                }
            }
            const frontDoorContainer = scene.querySelector('#front-door-container');
            if (frontDoorContainer) {
                frontDoorContainer.addEventListener('click', () => {
                    frontDoorContainer.dataset.active = 'true';
                    setTimeout(() => {
                        frontDoorContainer.dataset.active = 'false';
                    }, 1000);
                });
            }

             
            //----------------------------
            // IDLE ANIMATIONS

            const twinkleLightGlows = scene.querySelectorAll('[id^="twinkle-light-glow"]');
            if (twinkleLightGlows.length > 0 && window.innerWidth >= 1024) {
                // Set initial state for each light with random starting values
                twinkleLightGlows.forEach((light) => {
                    const randomStartOpacity = Math.random() * 0.3 + 0.3; // 0.3 to 0.8
                    const randomStartScale = Math.random() * 0.3 + 0.7; // 0.7 to 1.0
                    gsap.set(light, {
                        opacity: randomStartOpacity,
                        scale: randomStartScale,
                    });
                    
                    // Create individual timeline for each light with random timing
                    const randomDelay = Math.random() * 2; 
                    const randomDuration = Math.random() * 0.8 + 1.5; 
                    
                    const tl = gsap.timeline({ repeat: -1, delay: randomDelay });
                    tl.to(light, {
                        opacity: 1,
                        scale: 1,
                        duration: randomDuration,
                        ease: 'power2.inOut',
                    })
                    .to(light, {
                        opacity: 0.3,
                        scale: 0.7,
                        duration: randomDuration,
                        ease: 'power2.inOut',
                    });
                });
            }

            const raccoon = scene.querySelector('#Raccoons');
            if (raccoon) {
                raccoon.addEventListener('click', () => {
                    raccoon.dataset.active = 'true';
                    setTimeout(() => {
                        raccoon.dataset.active = 'false';
                    }, 1000);
                });
            }

            const snowman = scene.querySelector('#Snowman');
            if (snowman) {
                snowman.addEventListener('click', () => {
                    snowman.dataset.active = 'true';
                    setTimeout(() => {
                        snowman.dataset.active = 'false';
                    }, 1000);
                });
            }

        
            //Close the loading screen
            setTimeout(() => {
                const loader = document.querySelector('.holiday-interactive__loader');
                if (loader) {
                    loader.dataset.hidden = 'true';
                    setTimeout(() => {
                        loader.style.display = 'none';
                    }, 500);
                }
            }, 1500);
        }
    } // end initHolidayInteractive

    function initCountryOptin(){
        $(".js-details").hide();
        $("#country-input").change(function (){
            var countryOption = $(this).val();
            $(".js-details").hide();
            $("." + countryOption).show(); 
        })
    }

    function initProcessSVG(){
        //new Vivus('my-svg', {duration: 2200}, function(){});
    }

    function initStickyBlogNav(){
        // Track all sections that have an `id` applied 
        document.querySelectorAll('.post-content [id]').forEach((section) => {
            blogObserver.observe(section);
        });
    }

    function removeStickyBlogNav(){
        if (blogObserver){
            blogObserver.disconnect()
        }
    }
    
    //for block video auto play
    function initPlayVideoOnScroll(){
        // Track all sections that have a `class` applied 
        document.querySelectorAll('.post-content .video-block__video--play-on-scroll').forEach((video) => {
            videoObserver.observe(video);
        });
    }

    //for image-video block and hero media row auto play
    function initCaseStudyVideoOnScroll(){
        // Track all sections that have a `class` applied 
        document.querySelectorAll('.image-video__video--play-on-scroll').forEach((video) => {
            videoObserver.observe(video);
        });

        document.querySelectorAll('.hero-media-row__video--play-on-scroll').forEach((heroVideo) => {
            videoObserver.observe(heroVideo);
        });
    }

    function removePlayVideoOnScroll(){
        if (videoObserver){
            videoObserver.disconnect()
        }
    }
    
    // function initHomeVideo(){
    //     var vid = document.getElementById("intro-video");
    //     var $video = $('#intro-video');
    //     vid.oncanplaythrough = function() {
    //         $video.addClass('visible');
    //     };
    // }


    function initTeamPage(){

        // loadBootstrapModal().then(() => {

      

        // });

    }

    function initOurWorkIndex(){
        setTimeout(function(){

            // var support = { animations : Modernizr.cssanimations },
            //     animEndEventNames = { 'WebkitAnimation' : 'webkitAnimationEnd', 'OAnimation' : 'oAnimationEnd', 'msAnimation' : 'MSAnimationEnd', 'animation' : 'animationend' },
            //     animEndEventName = animEndEventNames[ Modernizr.prefixed( 'animation' ) ],
            //     onEndAnimation = function( el, callback ) {
            //         var onEndCallbackFn = function( ev ) {
            //             if( support.animations ) {
            //                 if( ev.target != this ) return;
            //                 this.removeEventListener( animEndEventName, onEndCallbackFn );
            //             }
            //             if( callback && typeof callback === 'function' ) { callback.call(); }
            //         };
            //         if( support.animations ) {
            //             el.addEventListener( animEndEventName, onEndCallbackFn );
            //         }
            //         else {
            //             onEndCallbackFn();
            //         }
            //     };

            // from http://www.sberry.me/articles/javascript-event-throttling-debouncing
            function throttle(fn, delay) {
                var allowSample = true;

                return function(e) {
                    if (allowSample) {
                        allowSample = false;
                        setTimeout(function() { allowSample = true; }, delay);
                        fn(e);
                    }
                };
            }

            // sliders - flickity
            var grid = document.querySelector('.grid'),
                // isotope instance
                iso,
                // filter ctrls
                filterCtrls = [].slice.call(document.querySelectorAll('.work-filter'));

            function init() {
                // preload images
                initIsotope();
                initEvents();
                classie.remove(grid, 'grid--loading');
                $('.our-work-cards').addClass('hover');
                $('.our-work-card:first-child').addClass('is-hovering');

            }

            function initIsotope() {
                iso = new Isotope( grid, {
                    isResizeBound: false,
                    itemSelector: '.grid__item',
                    //percentPosition: true,
                    layoutMode: 'packery',

//                masonry: {
//                    // use outer width of grid-sizer for columnWidth
//                    columnWidth: '.grid__sizer'
//                },
                    // transitionDuration: '0.6s'
                });

            }

            function initEvents() {
                filterCtrls.forEach(function(filterCtrl) {
                    filterCtrl.addEventListener('click', function() {
                        classie.remove(filterCtrl.parentNode.querySelector('.work-filter--selected'), 'work-filter--selected');
                        classie.add(filterCtrl, 'work-filter--selected');
                        iso.arrange({
                            filter: filterCtrl.getAttribute('data-filter')
                        });
                        //recalcFlickities();
                        iso.layout();
                    });
                });

                // window resize / recalculate sizes for both flickity and isotope/masonry layouts
                window.addEventListener('resize', throttle(function(ev) {
                    //recalcFlickities()
                    iso.layout();
                }, 50));


            }


            init();

        }, 1000);
    }

    function initOurWorkCard(){
        $('.our-work-card').hover(function(){
            $(this).addClass('is-hovering');
            $('.our-work-cards').addClass('hover');
        }, function(){
            $(this).removeClass('is-hovering');
            $('.our-work-cards').removeClass('hover');
        });
    }

    function initCaseStudyHeader() {
        if (document.querySelector(".case-study__header-visual-inner")){
            let mm = gsap.matchMedia();

            mm.add("(min-width: 1499px)", () => {
                gsap.from(".case-study__header-visual-inner", {
                    scrollTrigger: {
                        trigger: ".case-study__header-visual-inner",
                        start: "top 85%",
                        end: 'top 10%',
                        scrub: true,
                        markers: false
                    },
                    scale: 1.25,
                    duration: 0.5,
                    ease: 'slow'
                });
            })
        }
    }

    // Determine Mouse or Keyboard interaction
    // assume mouse by default 
    document.body.classList.add('using-mouse');
	document.body.addEventListener('mousedown', function() {
		document.body.classList.add('using-mouse');
	}); 
	document.body.addEventListener('keydown', function(event) {
		if (event.key === 'Tab' || event.key === 'Space') {
			document.body.classList.remove('using-mouse');
		}
	});


    var pageToRemove;
    var targetName;
    var $loading = $('.loading-animation');
    var activeTransition;
    var controller;
    var action;
    var windowWidth = $(window).width();
    //afterPageFunctions();

    function beforeFunc(){
        console.log("before");
    }

    function afterFunc(){
        console.log("after");
    }

    // =============================================================
    // Cookieless analytics (Fathom)
    // =============================================================
    function handleCookielessAnalytics() {
        console.log("Initializing cookieless analytics tracking...");
        // Ensure that the tracking listeners only get attached once (otherwise we get duplicate events)
        if (window.__analyticsListenersAttached) return;
        window.__analyticsListenersAttached = true;

    
        // HIGH_ENGAGEMENT_TRIGGER function:
        let triggered = false;
        let triggerObj = {};
        const high_engagement_trigger = (triggerReason, ctaText, engagementTier, immediate) => {
            if (triggered) {
                return; // we only want high_engagement_trigger to run ONCE.
            }

            console.log(`high_engagement_trigger called with reason: ${triggerReason}, ctaText: ${ctaText}, engagementTier: ${engagementTier}, immediate: ${immediate}`);

            // We're only tracking on key content pages (i.e. Specialties, Our Work, Thinking sections)
            const contentName = document.querySelector('title').text;
            let contentType;
            if (window.location.href.indexOf("/specialties") > -1) {
                contentType = "Specialties";
            } else if (window.location.href.indexOf("/our-work") > -1) {
                contentType = "Our Work";
            } else if (window.location.href.indexOf("/thinking-business-to-business-marketing") > -1) {
                contentType = "Thinking";
            }

            // Log the trigger details in the trigger object; if a second trigger occurs, add the new values to the object
            if (Object.keys(triggerObj).length === 0) {
                triggerObj.ct = contentType,
                triggerObj.tier = engagementTier,
                triggerObj.trig = [triggerReason],
                triggerObj.slug = new URL(window.location.href).pathname
            } else {
                triggerObj.trig.push(triggerReason);
                triggerObj.tier = "high";
            }

            console.log('Plausible high_intent_engagement trigger: ', triggerObj);

            // This is specifically for the CTA click. 
            // This is to ensure that the click triggers the event without the same 5sec delay in the function below,
            // because with the delay, the page unloads before the capture event can happen.
            if (immediate) {
                triggered = true;
                plausible('high_intent_engagement, { ' + 
                    'ct: ' + triggerObj.ct + ', ' + 
                    'tier: ' + triggerObj.tier + ', ' + 
                    'trig: ' + triggerObj.trig + ', ' +
                    'slug: ' + triggerObj.slug + ' }'
                )
            }

            // 5 second delay is for tracking engagement level/tier. 
            // After the first trigger, continue "listening" for 5 seconds to see if a second trigger occurs.
            // Then send both triggers together as one event.
            setTimeout(() => {
                if (!triggered) {
                    triggered = true;
                    plausible('high_intent_engagement, { ' + 
                        'ct: ' + triggerObj.ct + ', ' +
                        'tier: ' + triggerObj.tier + ', ' +
                        'trig: ' + triggerObj.trig + ', ' +
                        'slug: ' + triggerObj.slug + ' }'
                    );
                }
            }, 5000);
            

        }
        
        
        // EVENTS
        // ---------------------------------------------------------------

        // CTA Click Trigger (All contact buttons):
        const ctaBtns = document.querySelectorAll("a[href*='/contact/general-contact']");
        ctaBtns.forEach((btn) => {
            btn.addEventListener('click', function(event) {
                event.preventDefault();
    
                const url = event.currentTarget.href;

                high_engagement_trigger('cta_click', event.currentTarget.innerText.trim(), 'high', true);
    
                // set a minor delay before directing user to the href link
                // (give the data some time to be sent to Fathom before unloading the page)
                setTimeout(() => {
                    window.location.href = url;
                }, 150);
            });
        });
    
    
        // Scroll depth - User scrolls to ≥ 75% of the page.
        let scrollTracked = false; 
        scrollHandler = function() {
            if (scrollTracked) return;

            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollDepth = (scrollTop / docHeight) * 100;

            if (scrollDepth >= 75) {
                // console.log('75% scroll depth reached');
                high_engagement_trigger('scroll', null, 'low', false);
                scrollTracked = true;
            }
        };
        window.addEventListener('scroll', scrollHandler);
    
    
        // Time on page - User remains on page for ≥ 45 seconds.
        let timeOnPage = 0;
        onPageTimer = setInterval(() => {
            timeOnPage++;
            if (timeOnPage >= 45) {
                clearInterval(onPageTimer);
                // console.log('time on page = 45s');
                high_engagement_trigger('time', null, 'medium', false);
            }
        }, 1000);
        
    }


});



//convert px into rems
function convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}